import { useMemo } from 'react';
import { AdditiveBlending, BackSide, Color } from 'three';

const VERTEX = /* glsl */ `
  varying vec3 vN;
  varying vec3 vV;
  void main() {
    vN = normalize(normalMatrix * normal);
    vec4 mv = modelViewMatrix * vec4(position, 1.0);
    vV = normalize(-mv.xyz);
    gl_Position = projectionMatrix * mv;
  }
`;

const FRAGMENT = /* glsl */ `
  uniform vec3 uColor;
  uniform float uPower;
  uniform float uIntensity;
  varying vec3 vN;
  varying vec3 vV;
  void main() {
    float f = pow(clamp(dot(vN, vV), 0.0, 1.0), uPower);
    gl_FragColor = vec4(uColor, f * uIntensity);
  }
`;

// Back-side fresnel shell — the weak-GPU-safe atmosphere rim (research §1).
export function Atmosphere({ radius = 1, color = '#6f9fd8', power = 5, intensity = 0.7, scale = 1.055 }) {
  const uniforms = useMemo(
    () => ({
      uColor: { value: new Color(color) },
      uPower: { value: power },
      uIntensity: { value: intensity },
    }),
    [color, power, intensity],
  );

  return (
    <mesh scale={scale}>
      <sphereGeometry args={[radius, 48, 24]} />
      <shaderMaterial
        side={BackSide}
        transparent
        depthWrite={false}
        blending={AdditiveBlending}
        uniforms={uniforms}
        vertexShader={VERTEX}
        fragmentShader={FRAGMENT}
      />
    </mesh>
  );
}
